import Skeleton from '@mui/material/Skeleton';
import { useGoalById } from 'features/goals';
import React from 'react';
import { useParams } from 'react-router';
import { IconFormIcons, Target } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';

import * as Styled from './page-top-bar.style';

export const LoadingTitle: React.FC = () => (
  <Skeleton animation="wave" width="100%" height="1.8rem" />
);

export const Title: React.FC = () => {
  const { id } = useParams();
  const goal = useGoalById(id);

  return goal ? (
    <Styled.TitleContainer>
      <Styled.IllustrationContainer $color={undefined}>
        {!!goal.image && (
          <Styled.ImageContainer>
            <Styled.Image
              src={goal.image.url}
              alt={goal.name}
              hash={goal.image.blurHash}
            />
          </Styled.ImageContainer>
        )}

        {!goal.image && (
          <Styled.IconContainer>
            <Icon icon={IconFormIcons[goal.iconName!] ?? Target} />
          </Styled.IconContainer>
        )}
      </Styled.IllustrationContainer>

      <Styled.Title>{goal.name}</Styled.Title>
    </Styled.TitleContainer>
  ) : null;
};
